import { type ApiTag } from './tags';

export type Params = Record<string, string | number | boolean | undefined | null>;

interface CacheTagOptions {
  baseTag: ApiTag;
  params?: Params;
}

/**
 * Creates standardized cache tags for API endpoints
 * Allows for granular cache invalidation based on parameters
 *
 * @example
 * createCacheTags({
 *   baseTag: API_TAGS.CONSIGNMENTS,
 *   params: {
 *     projectId: 123,
 *     siteId: 456,
 *     page: 1
 *   }
 * })
 * // Returns: [
 * //   'Consignments',
 * //   { type: 'Consignments', id: 'projectId-123-siteId-456-page-1' }
 * // ]
 */
export function createCacheTags({ baseTag, params }: CacheTagOptions) {
  const tags: Array<ApiTag | { type: ApiTag; id: string }> = [baseTag];

  if (params) {
    const segments: string[] = [];

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        segments.push(`${key}-${value}`);
      }
    });

    // Add specific cache tag if we have segments
    if (segments.length > 0) {
      tags.push({ type: baseTag, id: segments.join('-') });
    }
  }

  return tags;
}
